import './BordSteps.scss';

interface IBordSteps {
  steps: string[];
  customGap?: string;
  currentStep?: number;
}

const BordSteps = ({ steps, customGap = '40px', currentStep = 0 }: IBordSteps) => {
  return (
    <section
      className="bordSteps"
      style={{
        gap: customGap,
        ['--progress' as string]: `${((currentStep + 1) / steps.length) * 100}%`
      }}
    >
      <span className="point pointStart" />
      {steps.map((step, index) => (
        <span key={`step-${index}`} className={`bordStep ${currentStep >= index ? 'bordStepActive' : ''}`}>
          {step}
        </span>
      ))}
      <span className="point pointEnd" />
    </section>
  );
};

export default BordSteps;
